import React from "react";
import { useTranslate } from "react-admin";
import { makeStyles } from "@material-ui/core";

const useDividerStyles = makeStyles(theme => ({
  container: {
    display: "flex",
    alignItems: "center",
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(0.5),
    width: '100%'
  },
  border: {
    borderBottom: `1px solid ${theme.palette.divider}`,
    width: "100%"
  },
  content: {
    paddingInline: theme.spacing(2),
    fontWeight: 500,
    fontSize: 14,
    flexGrow: 1,
    whiteSpace: "nowrap",
  }
}));

export const DividerWithText = ({ label, className }) => {
  const translate = useTranslate();
  const classes = useDividerStyles();

  return (
    <div className={`${classes.container} ${className || ''}`.trim()}>
      <div className={classes.border} />
      {label && <span className={classes.content}>{translate(label)}</span>}
      <div className={classes.border} />
    </div>
  );
};
